// extracted by mini-css-extract-plugin
export default {"internalCreditsModal":"InternalCreditsButton_internalCreditsModal__+xwLF"};